import { Route, Routes } from 'react-router-dom';
import ManageDatabase from '../../pages/ManageDatabase';
import ConverterRoutes from './ConverterRoutes/ConverterRoutes';
import SensorRoutes from './SensorRoutes/SensorRoutes';
import LocationRoutes from './LocationRoutes/LocationRoutes';
import FlowMeterRoutes from './FlowMeterRoutes/FlowMeterRoutes';
import FlowMeasurementRoutes from './FlowMeasurementRoutes/FlowMeasurementRoutes';

const ManageDatabaseRoutes = () => {
    return <Routes>
        <Route
            path='/'
            element={<ManageDatabase/>}
        />
        <Route 
            path='/converter/*'
            element={<ConverterRoutes />}
        />
        <Route 
            path='/sensor/*'
            element={<SensorRoutes />}
        />
        <Route 
            path='/location/*'
            element={<LocationRoutes />}
        />
        <Route 
            path='/flow-meter/*'
            element={<FlowMeterRoutes />}
        />
        <Route 
            path='/flow-measurement/*'
            element={<FlowMeasurementRoutes />}
        />
    </Routes>
};

export default ManageDatabaseRoutes;